import React from 'react';
import {
  FEED_TYPES,
  getLabelFromFeedType,
  getTotalsForFeedTypes,
} from '../../../../lib/feed';
import { useFeed } from '../../Feed';
import Total from '../../../../components/Total/Total';

import css from './FeedTypeFilter.module.css';

const FeedTypeFilter = () => {
  const {
    feedResultType,
    totals,
    isResultsLoading,

    setFeedResultType,
    clearSavedSearchFilter,
  } = useFeed();

  const totalResults = getTotalsForFeedTypes(totals);

  const handleFeedTypeClick = (type) => {
    clearSavedSearchFilter('type');
    setFeedResultType(type);
  };

  return (
    <div className={css.main}>
      <div
        className={css.type}
        data-cy="feed-filter-type"
        data-enabled={isResultsLoading ? 'disabled' : 'enabled'}
        data-status={feedResultType === 'all' ? 'selected' : 'unselected'}
        onClick={() => handleFeedTypeClick('all')}
      >
        <p className={css.name}>{getLabelFromFeedType('all')}</p>

        <Total isLoading={isResultsLoading} total={totalResults.all} />
      </div>
      {FEED_TYPES.map((type) => (
        <div
          key={type}
          className={css.type}
          data-cy="feed-filter-type"
          data-cy-type={type}
          data-enabled={isResultsLoading ? 'disabled' : 'enabled'}
          data-status={feedResultType === type ? 'selected' : 'unselected'}
          onClick={() => handleFeedTypeClick(type)}
        >
          <p className={css.name}>{getLabelFromFeedType(type)}</p>
          <Total isLoading={isResultsLoading} total={totalResults[type]} />
        </div>
      ))}
    </div>
  );
};

export default FeedTypeFilter;
